import { useTranslation } from 'react-i18next';
import LabShelf from '../../project/LabShelf/LabShelf';
import ProjectCard from '../../project/ProjectCard/ProjectCard';
import ProjectRows from '../../project/ProjectRows/ProjectRows';
import ProjectStage from '../../project/ProjectStage/ProjectStage';
import PillLink from '../../ui/PillLink/PillLink';
import Section from '../../ui/Section/Section';
import SectionHeader from '../../ui/SectionHeader/SectionHeader';
import { projectsOwnedAs } from '../../../data/projects';
import { showcase } from '../../../data/showcase';
import { useLanguage } from '../../../i18n/useLanguage';
import styles from './WorkSection.module.css';

const featuredProjects = projectsOwnedAs('product').filter((project) => project.slug !== showcase.project.slug);
const clientProjects = projectsOwnedAs('clientWork');
const labProjects = projectsOwnedAs('lab');

export default function WorkSection() {
    const { t } = useTranslation();
    const { localizedPath } = useLanguage();

    return (
        <>
            <section className={styles.stage} data-theme="light" aria-labelledby="work-stage-title">
                <div className="page-inner">
                    <ProjectStage showcase={showcase} headingId="work-stage-title" />
                </div>
            </section>
            <Section theme="dark" shape="sheet" id="work" labelledBy="work-title">
                <div className="page-inner">
                    <SectionHeader
                        id="work-title"
                        title={t('home.work.title')}
                        lead={t('home.work.lead')}
                        action={<PillLink href={localizedPath('/work')} variant="outline" icon="arrowRight">{t('home.work.action')}</PillLink>}
                    />
                    <div className={styles.showcase}>
                        <ul className={styles.featured}>
                            {featuredProjects.map((project) => (
                                <li key={project.slug}>
                                    <ProjectCard project={project} meta="fact" />
                                </li>
                            ))}
                        </ul>
                        <ProjectRows projects={clientProjects} />
                        <LabShelf projects={labProjects} headingId="work-lab-title" headingTag="h3" />
                    </div>
                </div>
            </Section>
        </>
    );
}
